/**
 * Decodes HTML entities in a text string
 * @param text - The text containing HTML entities
 * @returns The decoded text with HTML entities converted to their original characters
 */
export var decodeHtmlEntities = function decodeHtmlEntities(text) {
  if (!text) return ''; // Create a temporary DOM element to decode HTML entities

  var textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
};